import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import Loadable from "react-loadable";

const Leads = Loadable({
  loader: () => import("./routes/leads"),
  loading: TopBarProgress,
});
const FollowUp = Loadable({
  loader: () => import("./routes/followUp"),
  loading: TopBarProgress,
});

const Configurations = Loadable({
  loader: () => import("./routes/configurations"),
  loading: TopBarProgress,
});

const Funnel = Loadable({
  loader: () => import("./routes/funnel"),
  loading: TopBarProgress,
});

const Visits = Loadable({
  loader: () => import("./routes/visits"),
  loading: TopBarProgress,
});

const Owner = () => (
  <Switch>
    <Route path="/leads">
      <Leads />
    </Route>
    <Route path="/followUp">
      <FollowUp />
    </Route>
    <Route path="/funnel">
      <Funnel />
    </Route>
    <Route path="/configurations">
      <Configurations />
    </Route>
    <Route path="/visits">
      <Visits />
    </Route>
    <Redirect to="/leads" />
  </Switch>
);

export default Owner;
